export const VALID_URL_REGEXP =
  /^https:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#()?&//=]*)/;

// AI- or user-derived URLs are untrusted input. Only http(s) is safe to render as a clickable
// link — a `javascript:` or `data:` URL in an <a href> is an XSS / same-origin navigation vector.
// Anything that doesn't parse as an absolute http(s) URL must be treated as inert text, not a link.
export const isSafeHttpUrl = (url: string): boolean => {
  try {
    const { protocol } = new URL(url);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
};
